import { User } from '../../models/user.model';
import * as userActions from '../actions/user.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface UserState {
  user?: User;
  loaded: boolean;
  loading: boolean;
}

const initialState = {
  loaded: false,
  loading: false,
  user: null,
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case userActions.GET_USER:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case userActions.GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        user: action.payload,
      };
    case userActions.GET_USER_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const getUserState = createFeatureSelector<UserState>('userReducer');

export const getUser = (state: UserState) => state.user;
export const getUserLoaded = (state: UserState) => state.loaded;
export const getUserLoading = (state: UserState) => state.loading;
